import invariant from 'invariant'
import pathToRegexp from 'path-to-regexp-es6'
import queryString from 'query-string'

import { UUID_REGEXP, INT_REGEXP } from 'regexps'

interface BuildPathProps {
  queryParams?: Record<string, any>
  [key: string]: any
}

export class Url {
  route: string
  reverse: (params?: Record<string, any>) => string

  constructor(route: string) {
    this.route = route
    this.reverse = pathToRegexp.compile(route)
  }

  validateParams(params: Record<string, any>): void {
    Object.keys(params).forEach((key) => {
      if (key.endsWith('uuid')) {
        if (
          !String(params[key]).match(UUID_REGEXP) &&
          !String(params[key]).match(INT_REGEXP)
        ) {
          console.warn(`${key} param is not uuid/int (${params[key]})`)
        }
      }
    })
  }

  checkPath(pathname: string): boolean {
    const re = pathToRegexp(this.route)
    return re.test(pathname)
  }

  buildRoute(props: BuildPathProps = {}): string {
    return decodeURIComponent(this.buildPath(props))
  }

  buildPath(props: BuildPathProps = {}): string {
    const { queryParams = {}, ...params } = props
    try {
      this.validateParams(params)
    } catch (err) {
      console.error(err, { extra: { route: this.route, props } })
    }
    const search = queryString.stringify(queryParams)
    try {
      return search ? `${this.reverse(params)}?${search}` : this.reverse(params)
    } catch (err) {
      console.error(err)
      return '#'
    }
  }

  valueOf(): never {
    invariant(false, `Use "route" or "buildPath", route ${this.route}`)
    throw new Error('unreachable')
  }

  toString(): never {
    invariant(false, `Use "route" or "buildPath", route ${this.route}`)
    throw new Error('unreachable')
  }
}

export function url(route: string): Url {
  return new Url(route)
}

export function getUrlPatterns(urlPath: string) {
  return {
    list: `/${urlPath}/`,
    create: `/${urlPath}/`,
    retrieve: url(`/${urlPath}/:pk/`),
    update: url(`/${urlPath}/:pk/`),
    delete: url(`/${urlPath}/:pk/`),
  }
}
